import {
  Add,
  ChatBubbleOutline,
  Close,
  Edit,
  Delete,
  EmailOutlined,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Link,
  MoreVert,
  PhoneIphone,
  Search,
} from "@material-ui/icons";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { ErrorMessage, Field, Form, Formik } from "formik";
import htmlToDraft from "html-to-draftjs";
import $ from "jquery";
import moment from "moment";
import React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Button, Col, Dropdown, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Truncate from "react-truncate";
import { Mention, MentionsInput } from "react-mentions";
import { connect } from "react-redux";
import ReactSelect from "react-select";
import * as Yup from "yup";
import { getSpecialTaskAction } from "./../../actions/TransactionActions";
import {
  deleteSystemCampaignListAction,
  adminCopyCampaignMaterTemplateAction,
  adminCreatCampaignMaterTemplateAction,
  adminCreatEventCommMaterTemplateAction,
  adminDelEventCommunicationAction,
  adminGetCampDataByIdAction,
  adminGetMaterTemplateAction,
  adminGetVarriableRefAction,
  adminUpdateDependentTasksAction,
  adminUpdateMaterTemplateAction,
  getAllContigencyAction,
  GetDependencytasksAction,
  adminGetVariableRefAction,
} from "./../../actions/MasterTemplateActions";
import DependancyIcon from "./../../assets/img/dependancy-icon.svg";
import noTemplate from "./../../assets/img/no-template.jpg";
import Contingencies from "./../Transactions/Create/Contingencies";
import SetDependency from "./../Transactions/Detail/set-dependency";
import defaultStyle from "./defaultStyle";
import {
  getMinutes,
  cleanMentionFieldData,
  toastMessage,
} from "./../Common/Common";
import * as code from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
import DeletePrompt from "../Common/DeletePrompt";

const optionFilterType = [
  {
    value: "Email",
    label: "Email",
  },
  {
    value: "Text",
    label: "Text",
  },
  {
    value: "Interactive",
    label: "Interactive",
  },
];

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
  const result = {};
  if (source && destination && droppableSource && droppableDestination) {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(0, 0, removed);

    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;
  }
  return result;
};

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "#fff" : "#fff",

  width: "100%",
});

var emailTextValForEditor = EditorState.createEmpty();
var detailsValForEditor = EditorState.createEmpty();
var textValForEditor = EditorState.createEmpty();
var _ = require("lodash");

var initialValueAddTaskDefault = {
  taskTitle: "",
  taskType: "COMMUNICATION",
  communicationType: 0,
  emailTo: "",
  emailSubject: "",
  emailText: "",
  msgTo: "",
  msgText: "",
  assignee: "",
  detailsMsg: "",
  contingency: "",
  document: true,
  eventDay: 0,
  predecessorData: [],
  time: 540,
  isReminder: false,
  reminder: {
    day: 0,
    time: 480,
  },
  specialTask: [],
};

class MasterTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      adminMasterTemplates: [],
      addTask: "",
      communicationTask: "",
      interactiveTask: "",
      taskType: "Communication",
      showText: true,
      editCampaign: false,
      activeCampaign: "Select",
      campaignstyles: [],
      initialValueEditCampian: {
        campainId: "",
        campaignDays: 0,
        campainName: "",
        campaignDesc: "",
        contingencies: [],
        default: false,
      },
      campaignDaysCnt: 0,
      currentCampian: {},
      tempTemplate: {},
      initialValueAddTask: initialValueAddTaskDefault,
      isUpdate: false,
      contingencies: [],
      showLoader: true,
      variablesRefs: [],
      emailRefVar: [],
      textRefVar: [],
      AllRefVar: [],
      AllRefVarForMapping: [],
      AllRefVarForEditor: [],
      showEmailVariableList: false,
      showEmailVariableListStyle: { display: "none" },
      showTextVariableListStyle: { display: "none" },
      showAllVariableListStyle: { display: "none" },
      items: [],
      selected: [],
      tasksList: {},
      isCampUpdate: false,
      allContingencies: [],
      isTemplateOptSelected: false,
      isCampFromClone: false,
      DependencyModal: false,
      dependencyIsActive: false,
      moveConfirmationModal: false,
      affectedTasks: [],
      moveTaskPostData: {},
      moveErrorMessage: "",
      moveErrorModal: false,
      assigneeOptions: [
        {
          label: "select",
          value: "",
        },
      ],
      campContingencies: [],
      contingencyOptions: [],
      showFilterDropdown: false,
      originalTaskList: {},
      filterParam: {},
      filterType: null,
      filterContingency: null,
      filtered: false,

      searchParam: "",
      searched: false,
      specialTask: [],
      contingencyFilterList: {},
      activeCampaignId: "",
      deletePrompt: false,
      userId: "",
    };
  }

  /**
   * A semi-generic way to handle multiple lists. Matches
   * the IDs of the droppable container to the names of the
   * source arrays stored in the state.
   */
  id2List = {
    droppable: "items",
    droppable2: "selected",
    droppable0: "sd",
  };

  closeModal(e) {
    this.setState({
      DependencyModal: !this.state.DependencyModal,
    });
    this.changeCampaign(this.state.currentCampian._id);
  }

  getList = (id) => this.state.tasksList[id] || [];

  onDragEnd = (result) => {
    const { source, destination } = result;
    // dropped outside the list
    if (!destination) {
      return;
    }
    if (source.droppableId === destination.droppableId) {
      const items = reorder(
        this.getList(source.droppableId),
        source.index,
        destination.index
      );
      let state = { items };
      if (source.droppableId === "droppable2") {
        state = { selected: items };
      }
      this.setState(state);
    } else {
      const result1 = move(
        this.getList(source.droppableId),
        this.getList(destination.droppableId),
        source,
        destination
      );
      var tasksList = this.state.tasksList;
      tasksList[source.droppableId] = result1[source.droppableId];
      tasksList[destination.droppableId] = result1[destination.droppableId];
      tasksList[
        destination.droppableId
      ][0].day = destination.droppableId.replace("droppable", "");
      var data = this.getDataToPost(tasksList[destination.droppableId][0]);
      this.updateTaskData(data.initialValueAddTask, "drag");
      this.setState({
        tasksList,
      });
    }
  };

  // template horizontal scroll
  templatesScroll() {
    let getBodyScroll = $(".master-template-body").scrollLeft();
    $(".master-template-header").scrollLeft(getBodyScroll);
  }

  // got to date scroll
  goToDate() {
    let getDropdownVal = $(".go-to-dropdown").val();
    let getSingleColumnWidth = $(".master-template-column").outerWidth();
    $(".master-template-body").animate(
      {
        scrollLeft: getSingleColumnWidth * getDropdownVal,
      },
      800
    );
  }

  getStyle(style, snapshot) {
    if (!snapshot.isDropAnimating) {
      return style;
    }
    const { moveTo, curve, duration } = snapshot.dropAnimation;
    const translate = `translate(${moveTo.x}px, ${moveTo.y}px)`;
    const scale = "scale(1.05)";
    return {
      ...style,
      background: "#ff8",
      borderColor: "#e6e67a",
      transform: `${translate} ${scale}`,
      transition: `all ${curve} ${duration + 1}s`,
    };
  }

  /**
   * @desc open add task slide and set default data to be blank
   */
  addTaskSlide = (i, e) => {
    let day = 0;
    if (i === 0) {
      day = e.target.getAttribute("data-day");
    }
    emailTextValForEditor = EditorState.createEmpty();
    detailsValForEditor = EditorState.createEmpty();
    textValForEditor = EditorState.createEmpty();

    let initialValueAddTask = initialValueAddTaskDefault;
    initialValueAddTask.eventDay = day;
    initialValueAddTask.time = 540;
    initialValueAddTask.reminder.day = day;
    initialValueAddTask.reminder.time = 480;

    this.setState({ isUpdate: false });
    if (i == 0) {
      this.setState({
        addTask: "open",
        communicationTask: "",
        interactiveTask: "",
        initialValueAddTask,
        taskType: "COMMUNICATION",
        showText: true,
      });
    } else {
      this.setState({ addTask: "" });
    }
  };

  getTaskDataObject(taskData) {
    return {
      campaignId: this.state.currentCampian._id,
      eventtemplateId: taskData.eventtemplateId,
      eventDay: taskData.day,
      commId: taskData._id,
      taskTitle: taskData.label,
      taskType: taskData.type.name,
      contingency:
        taskData.contingency !== undefined ? taskData.contingency : "",
      document: true,
      predecessor: taskData.predecessor || [],
      successor: taskData.successor || [],
      predecessorData: taskData.predecessorData ? taskData.predecessorData : [],
      successorData: taskData.successorData ? taskData.successorData : [],
      time: taskData.time,
      isReminder: !!taskData.isReminder ? taskData.isReminder : false,
      reminder: {
        day:
          taskData.reminder !== undefined
            ? taskData.reminder.day
            : taskData.day,
        time: !!taskData.reminder.time ? taskData.reminder.time : 480,
      },
      specialTask:
        taskData.specialTask !== undefined ? taskData.specialTask : [],
    };
  }

  /**
   * @desc Get task data for sending post request (api call)
   * @param {*} taskData
   */
  getDataToPost(taskData) {
    let tempTemplate = taskData;
    let editTask = this.getTaskDataObject(taskData);

    if (taskData.type.name.toUpperCase() === "COMMUNICATION") {
      let showText = true;
      if (taskData.template.via.toUpperCase() === "EMAIL") {
        editTask.communicationType = 0;
        editTask.emailTo = taskData.template.to;
        editTask.emailSubject = taskData.template.subject;
        editTask.emailText = taskData.template.what;
        return {
          tempTemplate: tempTemplate,
          initialValueAddTask: editTask,
          taskType: "COMMUNICATION",
          showText: showText,
        };
      }
      if (taskData.template.via.toUpperCase() === "TEXT") {
        editTask.communicationType = 1;
        editTask.msgTo = taskData.template.to;
        editTask.msgText = taskData.template.what;
        showText = false;
        return {
          tempTemplate: tempTemplate,
          initialValueAddTask: editTask,
          taskType: "COMMUNICATION",
          showText: showText,
        };
      }
    }
    if (taskData.type.name.toUpperCase() === "INTERACTIVE") {
      editTask.assignee = taskData.assignee;
      editTask.detailsMsg = taskData.template.what;
      editTask.document =
        taskData.document !== undefined ? taskData.document : false;
      return {
        tempTemplate: tempTemplate,
        initialValueAddTask: editTask,
        taskType: "INTERACTIVE",
        showText: false,
      };
    }
  }

  /**
   * @desc set task data for edit mode and open modal
   * @param {*} taskData
   */
  editTask(taskData) {
    let assigneeOptions = [];
    this.state.variablesRefs.forEach((v) => {
      if (
        v.contingency !== undefined &&
        v.contingency !== "" &&
        taskData.contingency !== ""
      ) {
        if (
          (v.contingency === "all" || v.contingency === taskData.contingency) &&
          v.account === "user"
        ) {
          assigneeOptions.push({ label: v.name, value: v.name });
        }
      } else {
        if (v.account === "user") {
          assigneeOptions.push({ label: v.name, value: v.name });
        }
      }
    });
    this.setState({
      assigneeOptions,
    });
    // template data
    emailTextValForEditor = EditorState.createEmpty();
    detailsValForEditor = EditorState.createEmpty();
    textValForEditor = EditorState.createEmpty();

    let tempTemplate = taskData;
    // console.log(tempTemplate)
    //set edit data
    let editTask = this.getTaskDataObject(taskData);

    if (taskData.type.name.toUpperCase() === "COMMUNICATION") {
      if (taskData.template.via.toUpperCase() === "EMAIL") {
        let contentBlock = htmlToDraft(taskData.template.what);
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock.contentBlocks
          );
          emailTextValForEditor = !!contentState
            ? EditorState.createWithContent(contentState)
            : EditorState.createEmpty();
        }

        // emailToMapping array
        let emailToMappingArray =
          taskData.template.to !== undefined && taskData.template.to !== null
            ? taskData.template.to.split(" ")
            : [];

        let emailToMapping;
        for (
          emailToMapping = 0;
          emailToMapping < emailToMappingArray.length;
          emailToMapping++
        ) {
          let a = this.state.AllRefVarForMapping.indexOf(
            emailToMappingArray[emailToMapping]
          );
          if (a != -1) {
            //enclosing data within {()} for structure of mension input
            emailToMappingArray[emailToMapping] =
              "{(" + emailToMappingArray[emailToMapping] + ")}";
          }
        }

        // emailSubjectMapping array
        let emailSubjectMappingArray =
          taskData.template.subject !== undefined &&
          taskData.template.subject !== null
            ? taskData.template.subject.split(" ")
            : [];

        let emailSubjectMapping;
        for (
          emailSubjectMapping = 0;
          emailSubjectMapping < emailSubjectMappingArray.length;
          emailSubjectMapping++
        ) {
          let a = this.state.AllRefVarForMapping.indexOf(
            emailSubjectMappingArray[emailSubjectMapping]
          );
          if (a != -1) {
            //enclosing data within {()} for structure of mension input
            emailSubjectMappingArray[emailSubjectMapping] =
              "{(" + emailSubjectMappingArray[emailSubjectMapping] + ")}";
          }
        }

        editTask.communicationType = 0;
        editTask.emailTo = emailToMappingArray.join(" ");
        editTask.emailSubject = emailSubjectMappingArray.join(" ");
        editTask.emailText = taskData.template.what;

        this.setState({
          dependencyIsActive:
            editTask.predecessorData.length > 0 ? true : false,
          tempTemplate: tempTemplate,
          initialValueAddTask: editTask,
          taskType: "COMMUNICATION",
          showText: true,
        });
      }
      if (taskData.template.via.toUpperCase() === "TEXT") {
        // emailSubjectMapping array
        let msgToMappingArray =
          taskData.template.to !== undefined && taskData.template.to !== null
            ? taskData.template.to.split(" ")
            : [];

        let msgToMapping;
        for (
          msgToMapping = 0;
          msgToMapping < msgToMappingArray.length;
          msgToMapping++
        ) {
          let a = this.state.AllRefVarForMapping.indexOf(
            msgToMappingArray[msgToMapping]
          );
          if (a != -1) {
            //enclosing data within {()} for structure of mension input
            msgToMappingArray[msgToMapping] =
              "{(" + msgToMappingArray[msgToMapping] + ")}";
          }
        }

        editTask.communicationType = 1;
        editTask.msgTo = msgToMappingArray.join(" ");
        editTask.msgText = taskData.template.what;

        this.setState({
          dependencyIsActive:
            editTask.predecessorData.length > 0 ? true : false,
          tempTemplate: tempTemplate,
          initialValueAddTask: editTask,
          taskType: "COMMUNICATION",
          showText: false,
        });
      }

      this.setState({
        communicationTask: "",
        addTask: "open",
        interactiveTask: "",
      });
    }
    if (taskData.type.name.toUpperCase() === "INTERACTIVE") {
      let contentBlock = htmlToDraft(taskData.template.what);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        detailsValForEditor = !!contentState
          ? EditorState.createWithContent(contentState)
          : EditorState.createEmpty();
      }

      editTask.assignee = taskData.assignee;
      editTask.detailsMsg = taskData.template.what;
      editTask.document =
        taskData.template.document !== undefined
          ? taskData.template.document
          : false;

      this.setState({
        dependencyIsActive: editTask.predecessorData.length > 0 ? true : false,
        tempTemplate: tempTemplate,
        initialValueAddTask: editTask,
        taskType: "INTERACTIVE",
        showText: false,
        communicationTask: "",
        addTask: "open",
        interactiveTask: "",
      });
    }
    this.setState({ isUpdate: true });
  }

  // show Task Type
  showTaskType(e) {
    this.setState({ selectValue: e.target.value });
    if (e.target.value == "COMMUNICATION") {
      this.state.initialValueAddTask.taskType = "COMMUNICATION";
      this.setState({ taskType: "COMMUNICATION", showText: true });
      if (this.state.initialValueAddTask.communicationType === 0) {
        this.setState({ showText: true });
      } else {
        this.setState({ showText: false });
      }
    } else {
      this.state.initialValueAddTask.taskType = "INTERACTIVE";
      this.setState({ taskType: "INTERACTIVE", showText: false });
    }
  }

  // Communication Type condition
  showText(e) {
    if (e.target.value == "0") {
      this.state.initialValueAddTask.communicationType = 0;
      this.setState({ showText: true });
    } else {
      this.state.initialValueAddTask.communicationType = 1;
      this.setState({ showText: false });
    }
  }

  getActiveCampaign(eventKey, event) {
    this.setState({ activeCampaign: eventKey });
  }

  componentDidMount() {
    var getNavigator = navigator.userAgent;
    (function () {
      if (getNavigator.match("Macintosh")) {
        $(".master-template-header").addClass("mac");
      } else if (getNavigator.match("Windows")) {
        $(".master-template-header").addClass("win");
      }
    })();
    this.props.getAllContigencyAction().then((res) => {
      this.setState({ allContingencies: res });
    });
    this.getSpecialTasks();
  }

  /**
   * @desc open modal with default data
   * @param {*} data
   */
  createNewCampaign() {
    this.setState({
      editCampaign: !this.state.editCampaign,
      isCampUpdate: false,
    });
    this.setState({
      initialValueEditCampian: {
        campainName: "",
        campaignDays: "",
        campaignDesc: "",
        contingencies: [],
        default: false,
      },
    });
  }

  /**
   * @desc open  Edit Campaign modal and set selected campaign data to modal
   * @param {*} camp
   */
  editCampaign(camp) {
    // console.log('1 editCampaign - camp: ', camp);
    this.setState({ editCampaign: !this.state.editCampaign });
    if (camp !== "") {
      this.setState({
        initialValueEditCampian: {
          campainId: camp._id,
          campainName: camp.name,
          campaignDays: camp.campaignDays,
          campaignDesc: camp.description,
          contingencies: camp.contingencies,
          default: camp.default,
        },
        isCampUpdate: true,
        isTemplateOptSelected: true,
      });
    } else {
      let contigencies = [];
      for (let i = 0; i < this.state.allContingencies.length; i++) {
        contigencies.push({
          key: this.state.allContingencies[i].name,
          name: this.state.allContingencies[i].name,
          isParticipant: this.state.allContingencies[i].isParticipant,
          date: this.state.allContingencies[i].date,
        });
        // contigencies[this.state.allContingencies[i].name] = this.state.allContingencies[i].name;
      }
      this.setState({
        initialValueEditCampian: {
          campainName: "",
          campaignDays: "",
          campaignDesc: "",
          contingencies: contigencies,
          default: false,
        },
        isCampUpdate: false,
        isTemplateOptSelected: false,
        isCampFromClone: false,
      });
    }
  }

  /**
   * @desc open  Delete Campaign modal
   * @param {*} camp
   */
  openDeleteCampaign(camp) {
    const { _id } = camp;
    this.setState({
      deletePrompt: true,
      userId: _id,
    });
  }

  deleteCampaignListById() {
    this.setState({ showLoader: true, deletePrompt: false });
    this.postData = {
      id: this.state.userId,
      idDeleted: true,
    };
    this.props
      .deleteSystemCampaignListAction(this.postData)
      .then((res) => {
        // this.setState({ showLoader: false });
        this.loadDefaultTemplateData();
        toastMessage(code.SUCCESS, res.data.message);
      })
      .catch((err) => {
        this.setState({ showLoader: false });
      });
  }
  /**
   * @desc update campaign data - api call
   * @param {*} data
   */
  updateCampaignData(data) {
    this.setState({ editCampaign: !this.state.editCampaign, showLoader: true });
    let contingencies = data.contingencies;

    let postData = {
      name: data.campainName,
      description: data.campaignDesc,
      campaignDays: data.campaignDays,
      contingencies: contingencies,
      default: data.default,
    };
    // call api for update
    this.props
      .adminUpdateMaterTemplateAction(
        postData,
        "campaign",
        data.campainId,
        0,
        0,
        0
      )
      .then((res) => {
        //update contingencies to state
        let newcampaignstyles = this.state.campaignstyles;
        for (let i = 0; i < newcampaignstyles.length; i++) {
          if (newcampaignstyles[i]._id === data.campainId) {
            var prevDefault = newcampaignstyles[i].default;

            newcampaignstyles[
              i
            ].contingencies = this.props.updatedEventData.contingencies;
            newcampaignstyles[
              i
            ].campaignDesc = this.props.updatedEventData.description;
            newcampaignstyles[i].name = this.props.updatedEventData.name;
            newcampaignstyles[
              i
            ].campaignDays = this.props.updatedEventData.campaignDays;
          }
        }

        if (prevDefault !== this.props.updatedEventData.default) {
          this.loadDefaultTemplateData(); //load all to reflect default status in all
        } else {
          this.setState({ campaignstyles: newcampaignstyles });
          this.changeCampaign(data.campainId);
        }

        this.setState({ showLoader: false });
      });
  }

  selectCampaignCreate(e) {
    if (e.target.value == 0) {
      this.setState({ isTemplateOptSelected: true, isCampFromClone: true });
    } else {
      this.setState({ isTemplateOptSelected: true, isCampFromClone: false });
    }
  }

  /**
   * @desc Add new campaign data - API call
   * @param {*} data
   */
  createCampaign(data) {
    this.setState({ showLoader: true });
    let contingencies = data.contingencies;
    if (this.state.isTemplateOptSelected && this.state.isCampFromClone) {
      let postData = {
        campaign: data.selectedCampaign,
        name: data.campainName,
        description: "",
        campaignDays: data.campaignDays,
        contingencies: contingencies,
        default: data.default,
      };
      // call api for copy
      this.props.adminCopyCampaignMaterTemplateAction(postData).then((res) => {
        if (res.status === code.OK) {
          if (data.default) {
            this.loadDefaultTemplateData(); //load all to reflect default status in all
          } else {
            let newcampaign = this.state.campaignstyles;
            newcampaign.push(this.props.addedCampaign);
            this.setState({ campaignstyles: newcampaign });
            this.changeCampaign(this.props.addedCampaign._id);
          }

          this.setState({ showLoader: false });
        } else if (res.status === code.BAD_REQUEST) {
          this.editCampaign("");
          this.setState({ showLoader: false });
          toastMessage(code.ERROR, res.data);
        } else {
          this.setState({ showLoader: false });
          toastMessage(code.ERROR, res.data);
        }
      });
    } else {
      let postData = {
        name: data.campainName,
        description: data.campaignDesc,
        campaignDays: data.campaignDays,
        contingencies: contingencies,
        default: data.default,
      };
      postData.showSuccessMessage = false;
      // call api for create
      this.props
        .adminCreatCampaignMaterTemplateAction(postData)
        .then((res) => {
          if (res.status === code.OK) {
            if (data.default) {
              this.loadDefaultTemplateData(); //load all to reflect default status in all
            } else {
              let newcampaign = this.state.campaignstyles;
              newcampaign.push(this.props.addedCampaign);
              this.setState({ campaignstyles: newcampaign });
              this.changeCampaign(this.props.addedCampaign._id);
            }

            this.setState({ showLoader: false });
          } else {
            toastMessage(code.ERROR, res.data);
            this.setState({ showLoader: false });
          }
        })
        .catch((err) => {});
    }
    this.setState({ editCampaign: !this.state.editCampaign });
  }

  existingCampaignList() {
    let campaignList = [];
    for (let i = 0, len = this.state.campaignstyles.length; i < len; i++) {
      let camp = this.state.campaignstyles[i];
      if (!camp.isDeleted) {
        let data = (
          <option value={camp._id} key={"camp-" + camp._id}>
            {camp.name}
          </option>
        );
        campaignList.push(data);
      }
    }
    return campaignList;
  }
  /**
   * @desc update task data api call
   * @param {*} data
   * @param {*} dragType
   */
  updateTaskData(data, dragType) {
    if (dragType !== "drag") {
      this.setState({ showLoader: true });
    }
    let templateData = {};
    let postData = {
      eventtemplate: {
        _id: data.eventtemplateId,
        predecessor: data.predecessor,
        successor: data.successor,
        eventType: data.taskType,
        predecessorData: data.predecessorData ? data.predecessorData : [],
        successorData: data.successorData ? data.successorData : [],
        day: data.eventDay,
        title: data.taskTitle,
        contingency: data.contingency,
        campaign: this.state.currentCampian._id,
        time: data.time,
        isReminder: data.isReminder,
        reminder: data.isReminder
          ? {
              day:
                data.reminder !== undefined ? data.reminder.day : data.eventDay,
              time: !!data.reminder.time ? data.reminder.time : 480,
            }
          : {},
        specialTask: data.specialTask !== undefined ? data.specialTask : [],
      },
    };
    let type = 0;
    if (data.taskType === "INTERACTIVE") {
      type = 1;
      let to =
        data.assignee !== undefined &&
        data.assignee !== null &&
        data.assignee !== ""
          ? cleanMentionFieldData(data.assignee)
          : "";
      postData.eventtemplate.assignee = to;
      postData.eventtemplate.description = data.detailsMsg;
      postData.eventtemplate.document = data.document;
    } else {
      if (data.communicationType === 0) {
        // email
        let to = cleanMentionFieldData(data.emailTo);
        let sub = cleanMentionFieldData(data.emailSubject);

        templateData = {
          to: to,
          via: "EMAIL",
          subject: sub,
          what: data.emailText,
        };
      } else {
        //text
        let to = cleanMentionFieldData(data.msgTo);

        templateData = {
          to: to,
          via: "TEXT",
          subject: "",
          what: (data.msgText + "").replace(/\{\(/g, "").replace(/\)\}/g, ""),
        };
      }
      postData.communicationtemplate = {
        template: templateData,
        eventtemplateId: data.eventtemplateId,
      };
    }

    // call api for update
    this.props
      .adminUpdateMaterTemplateAction(
        postData,
        "both",
        0,
        data.eventtemplateId,
        data.commId,
        type
      )
      .then((res) => {
        if (res != undefined && res.length > 0) {
          var affectedTasks = res || [];
          this.setState({
            moveConfirmationModal: true,
            affectedTasks,
            moveTaskPostData: {
              postData: postData,
              model: "both",
              eventtemplateId: data.eventtemplateId,
              communicationtemplateId: data.commId,
              type: type,
            },
          });
        } else {
          if (res != undefined && res.hasOwnProperty("message")) {
            this.setState({
              moveErrorModal: true,
              moveErrorMessage: res.message,
            });
          } else {
            this.setState({ showLoader: true });
            this.props
              .adminUpdateDependentTasksAction(
                postData,
                "both",
                0,
                data.eventtemplateId,
                data.commId,
                type
              )
              .then((res) => {
                this.setState({ showLoader: false });
                this.changeCampaign(this.state.currentCampian._id);
              });
          }
        }
        this.clearFilter();
      });
    this.setState({
      addTask: "",
    });
  }

  /**
   * @desc crate new task - api call
   * @param {*} data
   */
  createTaskData(data) {
    this.setState({ showLoader: true });

    let postData = {
      campaign: this.state.currentCampian._id,
      title: data.taskTitle,
      day: data.eventDay,
      contingency: data.contingency,
      eventType: data.taskType,
      time: data.time,
      isReminder: data.isReminder,
      reminder: data.isReminder
        ? {
            day:
              data.reminder !== undefined ? data.reminder.day : data.eventDay,
            time: !!data.reminder.time ? data.reminder.time : 480,
          }
        : {},
      specialTask: data.specialTask !== undefined ? data.specialTask : [],
    };

    if (data.taskType === "INTERACTIVE") {
      postData["assignee"] = cleanMentionFieldData(data.assignee);
      postData.description = data.detailsMsg;
      postData.document = data.document;
    } else {
      if (data.communicationType === 0) {
        // email
        let to = cleanMentionFieldData(data.emailTo);
        let sub = cleanMentionFieldData(data.emailSubject);

        postData.communicationType = "EMAIL";
        postData.communicationTo = to;
        postData.communicationSubject = sub;
        postData.description = data.emailText;
      } else {
        //text
        let to = cleanMentionFieldData(data.msgTo);

        postData.communicationType = "TEXT";
        postData.communicationTo = to;
        if (data.msgText) {
          postData.description = (data.msgText + "")
            .replace(/\{\(/g, "")
            .replace(/\)\}/g, "");
        }
      }
    }

    this.props.adminCreatEventCommMaterTemplateAction(postData).then((res) => {
      this.changeCampaign(this.state.currentCampian._id);
      var initialValueAddTaskDefault = {
        taskTitle: "",
        taskType: "COMMUNICATION",
        communicationType: 0,
        emailTo: "",
        emailSubject: "",
        emailText: "",
        msgTo: "",
        msgText: "",
        assignee: "",
        detailsMsg: "",
        contingency: "",
        document: true,
        eventDay: 0,
        predecessorData: [],
        time: 540,
        isReminder: false,
        reminder: {
          day: 0,
          time: 480,
        },
        specialTask: [],
      };
      this.state.initialValueAddTask.taskType = "COMMUNICATION";
      this.setState({ taskType: "COMMUNICATION" });
      this.setState({ initialValueAddTask: initialValueAddTaskDefault }, () => {
        this.clearFilter();
      });
    });

    this.setState({ addTask: "" });
  }
  //Delete task - API call
  deleteTask(data) {
    var eventtemplateId = data.eventtemplateId;
    this.props.adminDelEventCommunicationAction(eventtemplateId).then((res) => {
      this.changeCampaign(this.state.currentCampian._id);
    });
  }
  //Clear data from modal inputs
  clearTaskDataFromModal() {
    this.setState({ initialValueAddTask: initialValueAddTaskDefault });
  }

  // DependencyModal Modal
  DependencyModal(vals, actiontaken) {
    if (vals) {
      let day = vals.eventDay;
      let event = vals.eventtemplateId;
      let selectedcampaign = vals.campaignId;
      this.props
        .GetDependencytasksAction(selectedcampaign, day, event, "ADMIN")
        .then((res) => {
          if (res.status == code.OK) {
            this.setState({
              DependencyModal: !this.state.DependencyModal,
              dependencytasklist: this.props.dependencyTasks,
              actiontaken,
            });
          }
        });
    } else {
      this.setState({ DependencyModal: !this.state.DependencyModal });
    }
  }

  componentWillMount() {
    // //call api for variable reference and devide it
    // this.props.adminGetVarriableRefAction().then(res => {
    // 	var emailRefVar = [];
    // 	var textRefVar = [];
    // 	var AllRefVar = [];
    // 	var AllRefVarForMapping = [];
    // 	var AllRefVarForEditor = [];

    // 	var variablesRefsOri = []

    // 	if (this.props.variablesRefs) {

    // 		variablesRefsOri = this.props.variablesRefs
    // 		for (let i = 0, len = this.props.variablesRefs.length; i < len; i++) {
    // 			if (this.props.variablesRefs[i].account !== "user") {
    // 				AllRefVar.push({ id: this.props.variablesRefs[i].name, display: this.props.variablesRefs[i].name })
    // 				AllRefVarForMapping.push(this.props.variablesRefs[i].name)
    // 				AllRefVarForEditor.push({
    // 					text: this.props.variablesRefs[i].name,
    // 					value: this.props.variablesRefs[i].name.replace("@", ''),
    // 					url: ''
    // 				});
    // 			}
    // 			if (this.props.variablesRefs[i].communicationtype === "EMAIL") {
    // 				emailRefVar.push({ id: this.props.variablesRefs[i].name, display: this.props.variablesRefs[i].name })
    // 			}
    // 			if (this.props.variablesRefs[i].communicationtype === "TEXT") {
    // 				textRefVar.push({ id: this.props.variablesRefs[i].name, display: this.props.variablesRefs[i].name })
    // 			}
    // 		}
    // 	}
    // 	this.setState({ variablesRefs: variablesRefsOri, emailRefVar: emailRefVar, textRefVar: textRefVar, AllRefVar: AllRefVar, AllRefVarForEditor: AllRefVarForEditor, AllRefVarForMapping: AllRefVarForMapping })
    // });
    this.loadDefaultTemplateData();
  }

  getVariableForTask(item) {
    this.setState({ showLoader: true });
    //call api for variable reference and devide it
    this.props
      .adminGetVariableRefAction(this.state.activeCampaignId)
      .then((res) => {
        var emailRefVar = [];
        var textRefVar = [];
        var AllRefVar = [];
        var AllRefVarForMapping = [];
        var AllRefVarForEditor = [];

        var variablesRefsOri = [];

        if (this.props.variablesRefs) {
          variablesRefsOri = this.props.variablesRefs;
          for (let i = 0, len = this.props.variablesRefs.length; i < len; i++) {
            if (this.props.variablesRefs[i].account !== "user") {
              AllRefVar.push({
                id: this.props.variablesRefs[i].name,
                display: this.props.variablesRefs[i].name,
              });
              AllRefVarForMapping.push(this.props.variablesRefs[i].name);
              AllRefVarForEditor.push({
                text: this.props.variablesRefs[i].name,
                value: this.props.variablesRefs[i].name.replace("@", ""),
                url: "",
              });
            }
            if (this.props.variablesRefs[i].communicationtype === "EMAIL") {
              emailRefVar.push({
                id: this.props.variablesRefs[i].name,
                display: this.props.variablesRefs[i].name,
              });
            }
            if (this.props.variablesRefs[i].communicationtype === "TEXT") {
              textRefVar.push({
                id: this.props.variablesRefs[i].name,
                display: this.props.variablesRefs[i].name,
              });
            }
          }
        }
        this.setState({
          variablesRefs: variablesRefsOri,
          emailRefVar: emailRefVar,
          textRefVar: textRefVar,
          AllRefVar: AllRefVar,
          AllRefVarForEditor: AllRefVarForEditor,
          AllRefVarForMapping: AllRefVarForMapping,
          showLoader: false,
        });
        if (item) {
          this.editTask(item);
        }
      });
  }
  /**
   * @desc get special task
   */
  getSpecialTasks() {
    this.props.getSpecialTaskAction().then((res) => {
      if (res.status == code.OK) {
        this.setState({ specialTask: res.data });
      }
    });
  }

  /**
   * @desc load default template while loading page
   * Here changed api response to other format of tasks based on date grouped and nessecery data combined into array to set data in ui
   */
  loadDefaultTemplateData() {
    this.props.adminGetMaterTemplateAction().then((res) => {
      let campaignstyles = [];
      // let activeCampaign = this.props.adminMasterTemplates[0];

      let filteredTemplates = this.props.adminMasterTemplates.filter(
        (item) => item.isDeleted === false
      );
      let activeCampaign = filteredTemplates[0];

      for (
        let i = 0, len = this.props.adminMasterTemplates.length;
        i < len;
        i++
      ) {
        let tempDataObj = this.props.adminMasterTemplates[i];
        let temData = {
          _id: tempDataObj._id,
          name: tempDataObj.name,
          description: tempDataObj.description,
          campaignDays: tempDataObj.campaignDays,
          createdDate: tempDataObj.createdDate,
          modifiedDate: tempDataObj.modifiedDate,
          contingencies: tempDataObj.contingencies,
          isDeleted: tempDataObj.isDeleted,
          default: tempDataObj.default,
        };
        campaignstyles.push(temData);

        if (
          !!tempDataObj.default &&
          tempDataObj.system &&
          !tempDataObj.isDeleted
        ) {
          activeCampaign = tempDataObj;
        }
      }
      this.setState({
        campaignstyles: campaignstyles,
        activeCampaignId: activeCampaign && activeCampaign._id,
        contingencies: campaignstyles.contingencies,
        showLoader: false,
      });
      //Set default data to load
      if (activeCampaign && activeCampaign._id) {
        this.setState({ showLoader: false });
        this.changeCampaign(activeCampaign._id);
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  /**
   * @desc get conigencies by campaign
   */
  getContingenciesByCamp() {
    let currentCampian = this.state.currentCampian;

    let data = [];
    data.push(
      <option value="" key={"contingencies" + 0}>
        Select
      </option>
    );
    for (let key in currentCampian.contingencies) {
      data.push(
        <option
          value={currentCampian.contingencies[key].name}
          key={currentCampian.contingencies[key].name}
        >
          {currentCampian.contingencies[key].name}
        </option>
      );
      // if (currentCampian.contingencies.hasOwnProperty(key)) {
      // 	data.push(<option value={key} key={key}>{key}</option>);
      // }
    }
    return data;
  }

  /**
   * @desc render daya layer for selected current campaign
   */
  renderDaysHeaderLayer() {
    let data = [];
    for (let i = 0, len = this.state.campaignDaysCnt; i < len; i++) {
      data.push(
        <div className="master-template-column" key={i}>
          <div>
            <h2>Day {i}</h2>
            <Button
              variant="primary"
              className="btn-blue"
              data-day={i}
              onClick={(e) => {
                this.addTaskSlide(0, e);
                this.getVariableForTask();
              }}
            >
              <Add className="mr-2" />
              Add New Task
            </Button>
          </div>
        </div>
      );
    }
    return data;
  }

  /**
   * @desc get list of days to set options for Days to task
   */
  getDaysList() {
    let data = [];
    for (let i = 0, len = this.state.campaignDaysCnt; i < len; i++) {
      data.push(
        <option value={i} key={i}>
          {i}
        </option>
      );
    }
    return data;
  }

  /**
   * @desc get list of days to set options for Remider Days to task
   */
  getReminderDaysList(eventDay) {
    let data = [];
    for (let i = 0, len = eventDay; i <= len; i++) {
      data.push(
        <option value={i} key={i}>
          {i}
        </option>
      );
    }
    return data;
  }

  /**
   * @desc render all task based on selected campaign
   */
  renderDefaultDaysTasks() {
    let data = [];
    for (let i = 0, len = this.state.campaignDaysCnt; i < len; i++) {
      let dayTasks = this.state.tasksList["droppable" + i] || [];

      data.push(
        <div className="master-template-column" key={"day-task" + i}>
          <Droppable droppableId={"droppable" + i}>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
              >
                {_.sortBy(dayTasks, "time").map((item, index) => (
                  <Draggable
                    className="demos"
                    key={item._id}
                    draggableId={item._id}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        className="card-single"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={this.getStyle(
                          provided.draggableProps.style,
                          snapshot
                        )}
                      >
                        <Dropdown
                          alignRight
                          className="dropdown-action card-action"
                        >
                          <Dropdown.Toggle
                            variant="transparent"
                            id="dropdown-folder1"
                            className="p-0"
                          >
                            <MoreVert />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              href=""
                              onClick={() => {
                                this.getVariableForTask(item);
                              }}
                            >
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              href=""
                              onClick={() => this.deleteTask(item)}
                            >
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        <div
                          className="card-single-content"
                          onClick={() => {
                            this.getVariableForTask(item);
                          }}
                        >
                          <Row>
                            <Col>
                              {item.type.name === "INTERACTIVE" ? (
                                <ChatBubbleOutline className="card-type" />
                              ) : (
                                <div>
                                  {item.template.via === "EMAIL" ? (
                                    <EmailOutlined className="card-type" />
                                  ) : (
                                    <PhoneIphone className="card-type" />
                                  )}
                                </div>
                              )}
                            </Col>
                          </Row>
                          <h2 title={item.label}>
                            <Truncate lines={2} ellipsis={"..."}>
                              {item.label}
                            </Truncate>
                          </h2>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
      );
    }
    return data;
  }

  /**
   * @desc render campaign days dropdown
   */
  renderCampaignDaysDropDown() {
    let campaignDaysDropDown = [];
    for (let i = 0, len = this.state.campaignDaysCnt; i < len; i++) {
      let data = (
        <option value={i} key={"campDay-" + i}>
          {i}
        </option>
      );
      campaignDaysDropDown.push(data);
    }
    return campaignDaysDropDown;
  }

  handleKeyDown(e) {
    if (e.key === "Enter" && e.shiftKey === true) {
      e.preventDefault();
    } else if (e.key === "Enter" && e.shiftKey === false) {
      e.preventDefault();
    }
  }

  /**
   * @desc change campaign load respection data
   * @param {*} id
   */
  changeCampaign(id) {
    this.setState({ showLoader: true, addTask: "", activeCampaignId: id });

    this.props
      .adminGetCampDataByIdAction(id)
      .then((res) => {
        //Set default data to load
        this.setState({
          campaignDaysCnt: this.props.campDataById[0].campaignDays,
          activeCampaign: this.props.campDataById[0].name,
        });
        this.setState({ currentCampian: this.props.campDataById[0] }, () => {
          this.getContingencyOptions();
        });

        let recordToLoad = "";
        let tasksList = {};
        if (this.props.campDataById !== undefined) {
          recordToLoad = this.props.campDataById[0];
        }
        let DayWiseTasks = [];
        if (
          recordToLoad !== undefined &&
          recordToLoad !== "" &&
          recordToLoad !== null
        ) {
          let events = recordToLoad.events;
          for (let i = 0, len = events.length; i < len; i++) {
            DayWiseTasks["day" + events[i].day] =
              DayWiseTasks["day" + events[i].day] || [];
            DayWiseTasks["day" + events[i].day].push(events[i]);
          }
        }

        for (let i = 0, len = this.state.campaignDaysCnt; i < len; i++) {
          var tasks =
            DayWiseTasks["day" + i] !== undefined
              ? DayWiseTasks["day" + i]
              : [];

          let dayTasks = [];

          for (let j = 0; j < tasks.length; j++) {
            if (tasks[j].type.name === "COMMUNICATION") {
              let communications =
                tasks[j] !== undefined && tasks[j].communication !== undefined
                  ? tasks[j].communication
                  : [];
              for (let k = 0; k < communications.length; k++) {
                let d = communications[k];
                d.type = tasks[j].type;
                d.eventType = tasks[j].eventType;
                d.isActive = tasks[j].isActive;
                d.predecessor = tasks[j].predecessor;
                d.predecessorData = tasks[j].predecessorData
                  ? tasks[j].predecessorData
                  : [];
                d.successorData = tasks[j].successorData
                  ? tasks[j].successorData
                  : [];
                d.successor = tasks[j].successor;
                d.day = tasks[j].day;
                d.label = tasks[j].title;

                d.contingency = tasks[j].contingency;
                d["modifiedDate"] = tasks[j].modifiedDate;
                d["time"] = tasks[j].time;
                d["isReminder"] = !!tasks[j].isReminder
                  ? tasks[j].isReminder
                  : false;
                d["reminder"] = !!tasks[j].reminder
                  ? tasks[j].reminder
                  : {
                      day: tasks[j].day,
                      time: 480,
                    };
                d["specialTask"] = !!tasks[j].specialTask
                  ? tasks[j].specialTask
                  : [];
                dayTasks.push(d);
              }
            } else {
              var d = { template: tasks[j].template };
              d._id = tasks[j]._id;
              d.eventtemplateId = tasks[j]._id;
              d.predecessor = tasks[j].predecessor;
              d.predecessorData = tasks[j].predecessorData
                ? tasks[j].predecessorData
                : [];
              d.successorData = tasks[j].successorData
                ? tasks[j].successorData
                : [];
              d.successor = tasks[j].successor;
              d.type = tasks[j].type;
              d.eventType = tasks[j].eventType;
              d.isActive = tasks[j].isActive;
              d.day = tasks[j].day;
              d.label = tasks[j].title;
              d.contingency = tasks[j].contingency;
              d["modifiedDate"] = tasks[j].modifiedDate;
              d["time"] = tasks[j].time;
              d["assignee"] = tasks[j].assignee;
              d["isReminder"] = !!tasks[j].isReminder
                ? tasks[j].isReminder
                : false;
              d["reminder"] = !!tasks[j].reminder
                ? tasks[j].reminder
                : {
                    day: tasks[j].day,
                    time: 480,
                  };
              d["specialTask"] = !!tasks[j].specialTask
                ? tasks[j].specialTask
                : [];
              dayTasks.push(d);
            }
            if (!!d && d.predecessorData.length > 0) {
              this.setState({
                dependencyIsActive: true,
              });
            } else {
              this.setState({
                dependencyIsActive: false,
              });
            }
          }
          dayTasks.sort((a, b) => {
            return a.modifiedDate > b.modifiedDate ? -1 : 1;
          });
          tasksList["droppable" + i] = dayTasks;
        }
        this.setState({
          tasksList,
          originalTaskList: tasksList,
          showLoader: false,
        });
      })
      .catch((err) => {});
  }

  /**
   * @desc get contingencies list by camp id for clone
   */
  getContingenciesByCampIdForClone(id) {
    let contingenciesListAr = this.state.campaignstyles;
    let data = [];
    for (let i = 0; i < contingenciesListAr.length; i++) {
      if (contingenciesListAr[i]._id === id) {
        contingenciesListAr[i].contingencies.forEach((contingency) =>
          data.push({
            name: contingency.name,
            val: contingency.val,
            isParticipant: contingency.isParticipant,
            isActive: contingency.isActive,
          })
        );
        // data = contingenciesListAr[i].contingencies;
      }
    }
    return data;
  }

  changeDay(type) {
    if (type == "prev") {
      $(".go-to-dropdown").val(
        $(".go-to-dropdown").val() - 1 >= 0 ? $(".go-to-dropdown").val() - 1 : 0
      );
    } else {
      $(".go-to-dropdown").val(
        Number($(".go-to-dropdown").val()) < this.state.campaignDaysCnt - 1
          ? Number($(".go-to-dropdown").val()) + 1
          : this.state.campaignDaysCnt - 1
      );
    }
    this.goToDate();
  }

  /**
   * @desc confirm move of task
   */
  confirmMove() {
    this.setState({ moveConfirmationModal: false, showLoader: true });
    this.props
      .adminUpdateDependentTasksAction(
        this.state.moveTaskPostData.postData,
        "both",
        0,
        this.state.moveTaskPostData.eventtemplateId,
        this.state.moveTaskPostData.communicationtemplateId,
        this.state.moveTaskPostData.type
      )
      .then((res) => {
        this.setState({ showLoader: false });
        this.changeCampaign(this.state.currentCampian._id);
      });
  }

  closeErrorModal() {
    this.setState({ moveErrorModal: false });
    this.changeCampaign(this.state.currentCampian._id);
  }

  /**
   * @desc update assignee option
   * @param {*} con
   * @param {*} setFieldValue
   */
  updateAssigneeOptions(con, setFieldValue) {
    let assigneeOptions = [];
    this.state.variablesRefs.forEach((v) => {
      if (v.contingency !== undefined && con !== "") {
        if (
          (v.contingency === "all" || v.contingency === con) &&
          v.account === "user"
        ) {
          assigneeOptions.push({ label: v.name, value: v.name });
        }
      } else {
        if (v.account === "user") {
          assigneeOptions.push({ label: v.name, value: v.name });
        }
      }
    });

    this.setState(
      {
        assigneeOptions,
      },
      () => {
        setFieldValue("assignee", "");
      }
    );
  }

  /**
   * @desc clear selected filter
   */
  clearFilter() {
    this.setState({
      filterContingency: null,
      filterType: null,
      tasksList: this.state.originalTaskList,
      filtered: false,
      searchParam: "",
      contingencyFilterList: {},
    });
  }

  /**
   * @desc filter master tempate task
   * @param {*} filterParam
   * @param {*} filterFrom
   */
  filterMasterTemplate(filterParam, filterFrom) {
    var tasksList = filterFrom;
    var returnTaskList = {};
    Object.keys(tasksList).forEach((e) => {
      returnTaskList[e] = tasksList[e].filter((task) => {
        var found = false;
        var found1 = false;
        var foundText = false;
        var foundEmail = false;
        filterParam.forEach((f) => {
          if (f) {
            if (f.value == "Interactive") {
              found = task.type.name === "INTERACTIVE";
            }
            if (f.value == "Text") {
              foundText = task.template.via === f.value.toUpperCase();
            }
            if (f.value == "Email") {
              foundEmail = task.template.via === f.value.toUpperCase();
            }
            if (task.contingency === f.value) {
              found1 = true;
            }
          }
          if (this.state.filterType == null) {
            found = true;
            foundText = true;
            foundEmail = true;
          }
          if (this.state.filterContingency == null) {
            found1 = true;
          }
        });
        return (found || foundText || foundEmail) && found1;
      });
    });
    this.setState({
      tasksList: returnTaskList,
      filtered: true,
      contingencyFilterList: returnTaskList,
    });
  }
  /**
   * @desc search within master template tasks using given param
   * @param {*} param
   * @param {*} searchFrom
   */
  searchMasterTemplate(param, searchFrom) {
    var tasksList =
      Object.keys(this.state.contingencyFilterList).length !== 0
        ? this.state.contingencyFilterList
        : searchFrom;

    var returnTaskList = {};
    Object.keys(tasksList).forEach((e) => {
      returnTaskList[e] = tasksList[e].filter((task) => {
        return (task.label + "")
          .trim()
          .toLowerCase()
          .includes((param + "").trim().toLowerCase());
      });
    });
    this.setState({
      tasksList: returnTaskList,
      searchParam: param,
    });
  }

  /**
   * @desc get contigencies as options
   */
  getContingencyOptions() {
    var options = [];
    for (let i = 0; i < this.state.currentCampian.contingencies.length; i++) {
      options.push({
        label: this.state.currentCampian.contingencies[i].name,
        value: this.state.currentCampian.contingencies[i].val,
      });
    }
    // Object.keys((this.state.currentCampian.contingencies || {})).forEach(e => {
    // 	options.push({ label: e, value: e })
    // })
    this.setState({ contingencyOptions: options });
  }

  getTaskFormValidations() {
    //Validatio  schema for task form
    var addTaskValidation = Yup.object().shape({
      taskTitle: Yup.string().required(message.ENTER_TASK_TITLE),
      taskType: Yup.string().required(message.SELECT_TASK_TYPE),
      contingency: Yup.string().required(message.SELECT_CONTINGENCY),
      communicationType: Yup.string().required(
        message.SELECT_COMMUNICATION_TYPE
      ),
      emailTo: Yup.string().required(message.ENTER_VALID_RICIPIENT),
      emailSubject: Yup.string().required(message.ENTER_SUBJECT),
    });

    if (this.state.taskType === "COMMUNICATION") {
      if (this.state.showText) {
        addTaskValidation = Yup.object().shape({
          taskTitle: Yup.string().required(message.ENTER_TASK_TITLE),
          taskType: Yup.string().required(message.SELECT_TASK_TYPE),
          contingency: Yup.string().required(message.SELECT_CONTINGENCY),
          communicationType: Yup.string().required(
            message.SELECT_COMMUNICATION_TYPE
          ),
          emailTo: Yup.string()
            .nullable()
            .required(message.ENTER_VALID_RICIPIENT)
            .test("mail", message.ENTER_VALID_EMAIL, (value) => {
              var emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
              if (value !== undefined) {
                var formatedValue = cleanMentionFieldData(value);
                if (value.match(emailFormat)) {
                  return true;
                } else if (formatedValue.charAt(0) === "@") {
                  return true;
                }
                return false;
              }
            }),
          emailSubject: Yup.string().required(message.ENTER_SUBJECT),
          emailText: Yup.string().required(message.ENTER_EMAIL_MESSAGE),
        });
      } else {
        addTaskValidation = Yup.object().shape({
          taskTitle: Yup.string().required(message.ENTER_TASK_TITLE),
          taskType: Yup.string().required(message.SELECT_TASK_TYPE),
          contingency: Yup.string().required(message.SELECT_CONTINGENCY),
          communicationType: Yup.string().required(
            message.SELECT_COMMUNICATION_TYPE
          ),
          msgTo: Yup.string()
            .nullable()
            .required(message.ENTER_TEXT_RECIPIENT)
            .test(
              "phone",
              "Please enter valid Phone Number, e.g 999-999-9999.",
              (value) => {
                var phoneformat = /(?:1?|\+1|\+\s1|\(?)(?:\(?|\s\(|[\.\-\s])\d{3}(?:\)?|\)\s|[\.\-\s])\d{3}[\.\-\s]\d{4}/g;
                if (value !== undefined) {
                  var formatedValue = cleanMentionFieldData(value);
                  if (value.match(phoneformat)) {
                    return true;
                  } else if (formatedValue.charAt(0) === "@") {
                    return true;
                  }
                  return false;
                }
              }
            ),

          msgText: Yup.string().required(message.ENTER_TEXT_MESSAGE),
        });
      }
    } else {
      addTaskValidation = Yup.object().shape({
        taskTitle: Yup.string().required(message.ENTER_TASK_TITLE),
        taskType: Yup.string().required(message.SELECT_TASK_TYPE),
        contingency: Yup.string().required(message.SELECT_CONTINGENCY),
        assignee: Yup.string().required(message.ENTER_ASSIGN_TO),
        detailsMsg: Yup.string().required(message.ENTER_DETAILS),
      });
    }
    return addTaskValidation;
  }

  render() {
    let campaignList = [];

    for (let i = 0, len = this.state.campaignstyles.length; i < len; i++) {
      let camp = this.state.campaignstyles[i];
      if (!camp.isDeleted) {
        let data = (
          <Dropdown.Item key={camp._id} as="li" eventKey={camp.name}>
            <div onClick={() => this.changeCampaign(camp._id)}>{camp.name}</div>
            <div>
              <Button
                className="mr-4"
                variant="transparent"
                onClick={() => this.editCampaign(camp)}
              >
                <Edit />
              </Button>
              <Button
                variant="transparent"
                onClick={() => this.openDeleteCampaign(camp)}
              >
                <Delete />
              </Button>
            </div>
          </Dropdown.Item>
        );
        campaignList.push(data);
      }
    }

    let addTaskValidation = this.getTaskFormValidations();

    return (
      <div className="master-template">
        <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head">
          <Col className="col-auto">
            <h4 className="title-med mt-0 pt-1">Master Templates</h4>
          </Col>

          <Col align="right">
            <Form className="justify-content-end form-inline">
              <Row className="trans-listing-head-row">
                <Col className="col-auto pl-0 d-flex trans-listing-head-button">
                  <div
                    className="mb-0 mx-auto form-group"
                    style={{ width: "350px" }}
                  >
                    <Dropdown
                      className="dropdown-campaign"
                      onSelect={(eventKey, event) =>
                        this.getActiveCampaign(eventKey, event)
                      }
                    >
                      <Dropdown.Toggle
                        variant="transparent"
                        id="dropdown-basic"
                      >
                        {this.state.activeCampaign}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>{campaignList}</Dropdown.Menu>
                    </Dropdown>
                  </div>
                </Col>
                <Col className="col-auto pl-0 d-flex trans-listing-head-button">
                  <div className="mb-0 form-group">
                    <Button
                      variant="primary"
                      className="btn-blue btn-head d-flex align-items-center"
                      onClick={() => this.editCampaign("")}
                    >
                      <Add className="mr-1" /> Create New Campaign
                    </Button>
                  </div>
                </Col>
                <Col
                  className="pl-0 master-drop-actions"
                  style={{ paddingRight: "10px" }}
                >
                  <Row className="mx-0 align-items-center">
                    <Col className="px-0 col-auto">
                      <Button
                        variant="transparent"
                        className="p-0"
                        onClick={() => {
                          this.changeDay("prev");
                        }}
                      >
                        <KeyboardArrowLeft />
                      </Button>
                    </Col>
                    <Col className="px-0">
                      <div className="mb-0 form-group">
                        <div className="c-select" style={{ width: "60px" }}>
                          <select
                            name="campaignDaysCnt"
                            id="campaignDaysCnt"
                            className="form-control form-control-sm form-control-head go-to-dropdown"
                            onChange={() => this.goToDate()}
                          >
                            {this.renderCampaignDaysDropDown()}
                          </select>
                        </div>
                      </div>
                    </Col>
                    <Col className="px-0 col-auto">
                      <Button
                        variant="transparent"
                        className="p-0"
                        onClick={() => {
                          this.changeDay("next");
                        }}
                      >
                        <KeyboardArrowRight />
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>

        <Row className="justify-content-between mx-0 align-items-center master-template-filter-row">
          <Col xs="3">
            <div className="icon-wrapper">
              <input
                type="text"
                className="form-control form-control-head"
                placeholder="Search"
                value={this.state.searchParam}
                onChange={(e) => {
                  this.searchMasterTemplate(
                    e.target.value,
                    this.state.originalTaskList
                  );
                }}
              />
              <span className="form-control-icn">
                <Search />
              </span>
            </div>
          </Col>

          <Col xs="4" className="pl-0">
            <ReactSelect
              isClearable={false}
              closeMenuOnSelect={true}
              placeholder="By Type"
              isMulti
              options={optionFilterType}
              className="react-select-wrapper react-select-multi react-select-buyer-multi"
              onChange={(e) => {
                this.setState({ filterType: e }, () => {
                  this.filterMasterTemplate(
                    _.concat(
                      this.state.filterContingency,
                      this.state.filterType
                    ),
                    this.state.originalTaskList
                  );
                  this.setState({ showFilterDropdown: false });
                });
              }}
              value={this.state.filterType}
            />
          </Col>
          <Col xs="4" className="pl-0">
            <ReactSelect
              isClearable={false}
              closeMenuOnSelect={true}
              placeholder="By Contingency"
              isMulti
              options={this.state.contingencyOptions}
              className="react-select-wrapper react-select-multi react-select-buyer-multi"
              onChange={(e) => {
                this.setState({ filterContingency: e }, () => {
                  this.filterMasterTemplate(
                    _.concat(
                      this.state.filterContingency,
                      this.state.filterType
                    ),
                    this.state.originalTaskList
                  );
                  this.setState({ showFilterDropdown: false });
                });
              }}
              value={this.state.filterContingency}
            />
          </Col>
          <Col className="col-auto pl-0">
            <Button
              variant="link"
              className="p-0 font-14"
              onClick={() => {
                this.clearFilter();
                this.setState({ showFilterDropdown: false });
              }}
            >
              Clear Filter
            </Button>
          </Col>
        </Row>

        <div className="master-template-container">
          {this.state.showLoader === true && (
            <div className="page-loader">
              <div className="page-loader-inner">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          )}
          <div className="master-template-content">
            <div className="master-template-row master-template-header more">
              {this.renderDaysHeaderLayer()}
            </div>

            <DragDropContext onDragEnd={this.onDragEnd}>
              <div
                className="master-template-body"
                onScroll={() => this.templatesScroll()}
              >
                <div className="master-template-row">
                  {this.renderDefaultDaysTasks()}
                </div>
              </div>
            </DragDropContext>

            {/* add task modal */}
            <div
              className={this.state.addTask + " calendar-add-task add-new-task"}
            >
              <Formik
                validateOnBlur={true}
                initialValues={this.state.initialValueAddTask}
                enableReinitialize={true}
                validationSchema={addTaskValidation}
                onSubmit={(values, { setSubmitting }) => {
                  if (this.state.isUpdate) {
                    this.updateTaskData(values, "submit");
                  } else {
                    this.createTaskData(values);
                  }
                }}
              >
                {({
                  errors,
                  values,
                  handleBlur,
                  setFieldValue,
                  touched,
                  setErrors,
                }) => (
                  <Form autocomplete="off">
                    <Row className="mx-0">
                      <Col>
                        <Button
                          variant="transparent"
                          className="close-task"
                          onClick={() => {
                            this.clearTaskDataFromModal();
                            this.addTaskSlide(1, "");
                          }}
                        >
                          <Close />
                        </Button>

                        <Row className="align-items-center">
                          <Col xs="8">
                            <h5 className="font-14 color-blue-4">Task Title</h5>
                          </Col>
                          <Col xs="4" align="right">
                            <Row className="justify-content-end mx-0 pr-4">
                              {this.state.dependencyIsActive ? (
                                <Col className="col-auto px-0">
                                  <Button
                                    variant="transparent"
                                    className="p-0 dep-btn"
                                    title="Check Dependency"
                                    onClick={() =>
                                      this.DependencyModal(values, "UPDATE")
                                    }
                                  >
                                    {/* <Link /> */}
                                    <img
                                      src={DependancyIcon}
                                      style={{ height: "24px", width: "24px" }}
                                      alt="dependency"
                                    />
                                  </Button>
                                </Col>
                              ) : (
                                this.state.isUpdate && (
                                  <Col className="col-auto px-0">
                                    <Dropdown
                                      alignRight
                                      className="task-action dropdown-action"
                                    >
                                      <Dropdown.Toggle
                                        variant="transparent"
                                        id="dropdown-basic"
                                        className="p-0"
                                      >
                                        <MoreVert />
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu>
                                        <Dropdown.Item
                                          onClick={() =>
                                            this.DependencyModal(values, "ADD")
                                          }
                                        >
                                          Set Dependency{" "}
                                          <Link style={{ height: "20px" }} />
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </Col>
                                )
                              )}
                            </Row>
                          </Col>
                          <Col xs="12">
                            <Field
                              name="taskTitle"
                              type="text"
                              value={values.taskTitle}
                              onChange={(e) => {
                                setFieldValue("taskTitle", e.target.value);
                              }}
                              className={
                                "task-add-input form-control field_ucfirst" +
                                (errors.taskTitle && touched.taskTitle
                                  ? " is-invalid"
                                  : "")
                              }
                              placeholder="Write task here"
                            />
                            <ErrorMessage
                              name="taskTitle"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row className="mx-0 mt-2 mb-2">
                      <Col xs="12" sm="4">
                        <h5 className="font-14 color-blue-4">Day</h5>
                        <div className="c-select">
                          <select
                            name="eventDay"
                            component="select"
                            value={values.eventDay}
                            className="form-control form-control-xs"
                            onChange={(e) =>
                              setFieldValue("eventDay", e.target.value)
                            }
                          >
                            {this.getDaysList()}
                          </select>
                        </div>
                      </Col>
                      <Col xs="12" sm="4">
                        <h5 className="font-14 color-blue-4">Time</h5>
                        <DatePicker
                          selected={
                            new Date(
                              moment()
                                .startOf("day")
                                .add({ minutes: values.time })
                                .format("YYYY-MM-DDTHH:mm:ssZ")
                            )
                          }
                          onChange={(date) =>
                            setFieldValue("time", getMinutes(date))
                          }
                          showTimeSelect
                          showTimeSelectOnly
                          // minTime={new Date(new Date().setHours(8, 0, 0, 0))}
                          // maxTime={new Date(new Date().setHours(21, 0, 0, 0))}
                          timeIntervals={30}
                          timeCaption="Time"
                          dateFormat="h:mm aa"
                          className="form-control time-task form-control-xs pl-1"
                        />
                      </Col>
                    </Row>

                    <Row className="mx-0 mt-2 mb-2">
                      <Col xs="12" sm="4">
                        <h5 className="font-14 color-blue-4">Contingency</h5>
                        <div className="c-select">
                          <select
                            name="contingency"
                            component="select"
                            value={values.contingency}
                            className="form-control form-control-xs"
                            onChange={(e) => {
                              setFieldValue("contingency", e.target.value);
                              this.updateAssigneeOptions(
                                e.target.value,
                                setFieldValue
                              );
                            }}
                          >
                            {this.getContingenciesByCamp()}
                          </select>
                        </div>
                        <ErrorMessage
                          name="contingency"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </Col>
                    </Row>

                    <Row className="mx-0 mt-2 mb-2">
                      <Col xs="12" sm="4">
                        <h5 className="font-14 color-blue-4">Task Type</h5>
                        <div className="c-select">
                          <select
                            name="taskType"
                            component="select"
                            value={values.taskType}
                            className="form-control form-control-xs"
                            onChange={(e) => {
                              setFieldValue("taskType", e.target.value);
                              this.updateAssigneeOptions(
                                values.contingency,
                                setFieldValue
                              );
                              this.showTaskType(e);
                              setErrors({});
                            }}
                          >
                            <option value="COMMUNICATION">Communication</option>
                            <option value="INTERACTIVE">Interactive</option>
                          </select>
                        </div>
                      </Col>

                      {this.state.taskType == "INTERACTIVE" ? (
                        <Col xs="12" sm="4">
                          <h5 className="font-14 color-blue-4">Special Task</h5>
                          <div className="c-select">
                            <select
                              name="specialTask"
                              component="select"
                              value={values.specialTask}
                              className="form-control form-control-xs"
                              onChange={(e) => {
                                setFieldValue("specialTask", [e.target.value]);
                              }}
                            >
                              <option value="">Select</option>
                              {this.state.specialTask &&
                              this.state.specialTask !== undefined
                                ? this.state.specialTask.map((e) => {
                                    return (
                                      <option key={e.name} value={e.value}>
                                        {e.name}
                                      </option>
                                    );
                                  })
                                : ""}
                            </select>
                          </div>
                        </Col>
                      ) : (
                        ""
                      )}
                    </Row>

                    {/* Set Reminder */}

                    <Row className="mx-0 my-3 date-block-wrapper task-single">
                      {values.isReminder ? (
                        ""
                      ) : (
                        <Col className="reminder-block col-auto">
                          <div className="custom-control custom-checkbox custom-control-inline">
                            <input
                              type="checkbox"
                              onChange={(e) => {
                                setFieldValue("isReminder", e.target.checked);
                              }}
                              className="custom-control-input"
                              id="checkReminder"
                              name="checkReminder"
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="checkReminder"
                            >
                              Set Reminder
                            </label>
                          </div>
                        </Col>
                      )}

                      {values.isReminder && (
                        <Col xs="12">
                          <hr className="mt-0 mb-2" />
                          <h5 className="font-15 color-blue-4">Set Reminder</h5>
                          <Row>
                            <Col xs="12" sm="4">
                              <h5 className="font-14 color-blue-4">Day</h5>
                              <div className="c-select">
                                <select
                                  name="reminder.day"
                                  component="select"
                                  value={values.reminder.day}
                                  className="form-control form-control-xs"
                                  onChange={(e) =>
                                    setFieldValue(
                                      "reminder.day",
                                      e.target.value
                                    )
                                  }
                                >
                                  {this.getReminderDaysList(values.eventDay)}
                                </select>
                              </div>
                            </Col>
                            <Col xs="12" sm="4">
                              <h5 className="font-14 color-blue-4">Time</h5>
                              <DatePicker
                                selected={
                                  new Date(
                                    moment()
                                      .startOf("day")
                                      .add({ minutes: values.reminder.time })
                                      .format("YYYY-MM-DDTHH:mm:ssZ")
                                  )
                                }
                                onChange={(date) =>
                                  setFieldValue(
                                    "reminder.time",
                                    getMinutes(date)
                                  )
                                }
                                // minTime={
                                //   values.eventDay == values.reminder.day
                                //     ? new Date(new Date().setHours(8, 0, 0, 0))
                                //     : ""
                                // }
                                // maxTime={
                                //   values.eventDay == values.reminder.day
                                //     ? new Date(
                                //         new Date().setHours(
                                //           0,
                                //           values.time - 60,
                                //           0,
                                //           0
                                //         )
                                //       )
                                //     : ""
                                // }
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={30}
                                timeCaption="Time"
                                dateFormat="h:mm aa"
                                className="form-control time-task form-control-xs pl-1"
                              />
                            </Col>
                            <Col xs="12" sm="4" className="pl-0 pt-4">
                              <Button
                                variant="link"
                                onClick={(e) => {
                                  setFieldValue("isReminder", false);
                                  setFieldValue(
                                    "reminder.day",
                                    values.eventDay
                                  );
                                  setFieldValue("reminder.time", 480);
                                }}
                                className="p-0 clear-reminder position-static"
                              >
                                <Close />
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      )}
                    </Row>

                    <div style={{ backgroundColor: "#f8f8f8" }}>
                      {this.state.taskType === "COMMUNICATION" ? (
                        // task communication
                        <div>
                          <Row className="mx-0 bg-blue-5 py-2 mb-2">
                            <Col xs="12">
                              <h5 className="font-14 color-blue-4 mb-1">
                                Communication Type
                              </h5>

                              <div className="form-group mb-0">
                                <div className="custom-control custom-radio custom-radio-sm custom-control-inline">
                                  <input
                                    name="communicationType"
                                    type="radio"
                                    className="custom-control-input"
                                    id="check1"
                                    value={0}
                                    onChange={(e) => {
                                      this.showText(e);
                                      setFieldValue("communicationType", 0);
                                      setErrors({});
                                    }}
                                    checked={
                                      values.communicationType === 0
                                        ? "checked"
                                        : ""
                                    }
                                  />

                                  <label
                                    className="custom-control-label color-grey-1"
                                    htmlFor="check1"
                                  >
                                    Email
                                  </label>
                                </div>
                                <div className="custom-control custom-radio custom-radio-sm custom-control-inline">
                                  <input
                                    name="communicationType"
                                    type="radio"
                                    className="custom-control-input"
                                    id="check2"
                                    value={1}
                                    onChange={(e) => {
                                      this.showText(e);
                                      setFieldValue("communicationType", 1);
                                      setErrors({});
                                    }}
                                    checked={
                                      values.communicationType === 1
                                        ? "checked"
                                        : ""
                                    }
                                  />
                                  <label
                                    className="custom-control-label color-grey-1"
                                    htmlFor="check2"
                                  >
                                    Text
                                  </label>
                                </div>
                              </div>
                            </Col>
                          </Row>

                          {this.state.showText ? (
                            <div>
                              <Row className="mx-0 mail-row">
                                <Col className="col-auto pr-0">
                                  <h5 className="font-14 color-blue-4 mb-0">
                                    To
                                  </h5>
                                </Col>
                                <Col className="mail-row-field mail-row-field-regular">
                                  <MentionsInput
                                    singleLine
                                    name="emailTo"
                                    type="text"
                                    value={values.emailTo}
                                    className={
                                      "mail-row-mension " +
                                      (errors.emailTo && touched.emailTo
                                        ? " is-invalid"
                                        : "")
                                    }
                                    onChange={(e) => {
                                      setFieldValue("emailTo", e.target.value);
                                    }}
                                    style={defaultStyle}
                                  >
                                    <Mention
                                      trigger="@"
                                      appendSpaceOnAdd={true}
                                      data={this.state.emailRefVar}
                                      markup="{(__id__)}"
                                    />
                                  </MentionsInput>

                                  <ErrorMessage
                                    name="emailTo"
                                    component="div"
                                    className="invalid-feedback"
                                    style={{ display: "block" }}
                                  />
                                </Col>
                              </Row>
                              <hr className="mt-2 mb-2" />
                              <Row className="mx-0 mail-row">
                                <Col className="col-auto pr-0">
                                  <h5 className="font-14 color-blue-4 mb-0">
                                    Subject
                                  </h5>
                                </Col>
                                <Col className="mail-row-field mail-row-field-big">
                                  <MentionsInput
                                    singleLine
                                    name="emailSubject"
                                    type="text"
                                    value={values.emailSubject}
                                    className={
                                      "mail-row-mension " +
                                      (errors.emailSubject &&
                                      touched.emailSubject
                                        ? " is-invalid"
                                        : "")
                                    }
                                    onChange={(e) => {
                                      setFieldValue(
                                        "emailSubject",
                                        e.target.value
                                      );
                                    }}
                                    style={defaultStyle}
                                  >
                                    <Mention
                                      trigger="@"
                                      appendSpaceOnAdd={true}
                                      data={this.state.AllRefVar}
                                      markup="{(__id__)}"
                                    />
                                  </MentionsInput>

                                  <ErrorMessage
                                    name="emailSubject"
                                    component="div"
                                    className="invalid-feedback"
                                    style={{ display: "block" }}
                                  />
                                </Col>
                              </Row>
                            </div>
                          ) : (
                            <Row className="mx-0 mail-row">
                              <Col className="col-auto pr-0">
                                <h5 className="font-14 color-blue-4 mb-0">
                                  To
                                </h5>
                              </Col>
                              <Col className="mail-row-field mail-row-field-regular">
                                <MentionsInput
                                  singleLine
                                  name="msgTo"
                                  type="text"
                                  value={values.msgTo}
                                  className={
                                    "mail-row-mension " +
                                    (errors.msgTo && touched.msgTo
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={(e) => {
                                    setFieldValue("msgTo", e.target.value);
                                  }}
                                  style={defaultStyle}
                                >
                                  <Mention
                                    trigger="@"
                                    appendSpaceOnAdd={true}
                                    data={this.state.textRefVar}
                                    markup="{(__id__)}"
                                  />
                                </MentionsInput>

                                <ErrorMessage
                                  name="msgTo"
                                  component="div"
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                />
                              </Col>
                            </Row>
                          )}

                          <hr className="mt-2 mb-2" />

                          <Row className="mx-0">
                            {this.state.showText ? (
                              <Col xs="12">
                                <div className="editor-main">
                                  <Editor
                                    wrapperClassName="demo-wrapper"
                                    editorClassName="demo-editor"
                                    mention={{
                                      separator: " ",
                                      trigger: "@",
                                      suggestions: this.state
                                        .AllRefVarForEditor,
                                    }}
                                    toolbar={{
                                      options: [
                                        "inline",
                                        "list",
                                        "link",
                                        "blockType",
                                      ],
                                      inline: {
                                        inDropdown: false,
                                        options: ["bold", "italic"],
                                      },
                                      list: {
                                        inDropdown: true,
                                        options: ["unordered", "ordered"],
                                      },
                                      link: {
                                        inDropdown: false,
                                        options: ["link"],
                                      },
                                      blockType: {
                                        inDropdown: false,
                                        options: ["Blockquote"],
                                      },
                                    }}
                                    name="emailText"
                                    handlePastedText={() => false}
                                    editorState={
                                      emailTextValForEditor !== undefined
                                        ? emailTextValForEditor
                                        : EditorState.createEmpty()
                                    }
                                    onEditorStateChange={(e) => {
                                      var ediData = draftToHtml(
                                        convertToRaw(e.getCurrentContent())
                                      );
                                      var tempDom = $("<output>").append(
                                        $.parseHTML(ediData)
                                      );

                                      let finalval = tempDom.html();
                                      let checkTags = finalval
                                        .replace("<p>", "")
                                        .replace("</p>", "");

                                      if (
                                        !checkTags.replace(/\s/g, "").length
                                      ) {
                                        setFieldValue("emailText", "");
                                      } else {
                                        setFieldValue("emailText", finalval);
                                      }
                                      emailTextValForEditor = e;
                                    }}
                                    hashtag={{}}
                                  />
                                </div>

                                <ErrorMessage
                                  name="emailText"
                                  component="div"
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                />
                              </Col>
                            ) : (
                              <Col xs="12">
                                <MentionsInput
                                  multiLine
                                  name="msgText"
                                  type="textarea"
                                  value={values.msgText}
                                  className={
                                    " " +
                                    (errors.msgText && touched.msgText
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={(e) => {
                                    setFieldValue("msgText", e.target.value);
                                  }}
                                  style={defaultStyle}
                                >
                                  <Mention
                                    trigger="@"
                                    appendSpaceOnAdd={true}
                                    data={this.state.AllRefVar}
                                    markup="{(__id__)}"
                                  />
                                </MentionsInput>
                                <ErrorMessage
                                  name="msgText"
                                  component="div"
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                />
                              </Col>
                            )}
                          </Row>
                        </div>
                      ) : (
                        // task Interactive
                        <div>
                          <Row className="mx-0 mb-2 bg-blue-5 py-2">
                            <Col>
                              <div className="custom-control custom-checkbox custom-control-inline">
                                <input
                                  name="document"
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="docRequired"
                                  defaultChecked
                                  checked={values.document}
                                  onChange={(e) => {
                                    setFieldValue("document", e.target.checked);
                                  }}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="docRequired"
                                >
                                  Document upload required
                                </label>
                              </div>
                            </Col>
                          </Row>
                          <Row className="mx-0 mail-row assign-var-row assign-var-row-first">
                            <Col className="col-auto pr-0 assign-var-label">
                              <h5 className="font-14 color-blue-4 mb-0">
                                Assign to
                              </h5>
                            </Col>
                            <Col className="mail-row-field mail-row-field-large assign-var-select assign-var-select">
                              <ReactSelect
                                onBlur={handleBlur}
                                fullWidth
                                onChange={(e) => {
                                  setFieldValue("assignee", e.value);
                                }}
                                value={{
                                  label: values.assignee,
                                  value: values.assignee,
                                }}
                                className="react-select-wrapper react-select-multi"
                                name="assignee"
                                options={this.state.assigneeOptions}
                              />

                              <ErrorMessage
                                name="assignee"
                                component="div"
                                className="invalid-feedback"
                                style={{ display: "block" }}
                              />
                            </Col>
                          </Row>
                          <hr className="mt-2 mb-2" />
                          <Row className="mx-0">
                            <Col>
                              <h5 className="font-14 color-blue-4">Detail</h5>
                              <div className="editor-main">
                                <Editor
                                  wrapperClassName="demo-wrapper"
                                  editorClassName="demo-editor"
                                  mention={{
                                    separator: " ",
                                    trigger: "@",
                                    suggestions: this.state.AllRefVarForEditor,
                                  }}
                                  toolbar={{
                                    options: [
                                      "inline",
                                      "list",
                                      "link",
                                      "blockType",
                                    ],
                                    inline: {
                                      inDropdown: false,
                                      options: ["bold", "italic"],
                                    },
                                    list: {
                                      inDropdown: true,
                                      options: ["unordered", "ordered"],
                                    },
                                    link: {
                                      inDropdown: false,
                                      options: ["link"],
                                    },
                                    blockType: {
                                      inDropdown: false,
                                      options: ["Blockquote"],
                                    },
                                  }}
                                  handlePastedText={() => false}
                                  name="detailsMsg"
                                  editorState={
                                    detailsValForEditor !== undefined
                                      ? detailsValForEditor
                                      : EditorState.createEmpty()
                                  }
                                  onEditorStateChange={(e) => {
                                    var ediData = draftToHtml(
                                      convertToRaw(e.getCurrentContent())
                                    );
                                    var tempDom = $("<output>").append(
                                      $.parseHTML(ediData)
                                    );

                                    let finalval = tempDom.html();

                                    let checkTags = finalval
                                      .replace("<p>", "")
                                      .replace("</p>", "");

                                    if (!checkTags.replace(/\s/g, "").length) {
                                      setFieldValue("detailsMsg", "");
                                    } else {
                                      setFieldValue("detailsMsg", finalval);
                                    }

                                    detailsValForEditor = e;
                                  }}
                                  hashtag={{}}
                                />
                                <ErrorMessage
                                  name="detailsMsg"
                                  component="div"
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>
                      )}
                      <Row className="mx-0 py-3">
                        <Col xs="6">
                          <Button
                            type="submit"
                            size="sm"
                            className="btn-blue w-140"
                          >
                            {this.state.isUpdate ? "Update Task" : "Add Task"}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>

        {/* Edit Campaign Modal */}
        <Modal
          show={this.state.editCampaign}
          onHide={() => this.editCampaign("")}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med1 create-template-modal"
        >
          <Formik
            validateOnBlur={true}
            initialValues={this.state.initialValueEditCampian}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
              selectedCampaign:
                this.state.isCampFromClone && !this.state.isCampUpdate
                  ? Yup.string().required("Please select campaign")
                  : Yup.string().nullable(),
              campainName: Yup.string().required(message.ENTER_CAMPAIGN_NAME),
              campaignDays: Yup.string()
                .nullable()
                .trim()
                .required(message.ENTER_CAMPAIGN_DURATION),
            })}
            onSubmit={(values) => {
              if (this.state.isCampUpdate) {
                this.updateCampaignData(values);
              } else {
                this.createCampaign(values);
              }
            }}
          >
            {({
              errors,
              values,
              setFieldValue,
              touched,
              handleBlur,
              setFieldTouched,
            }) => (
              <Form
                className="form-sm form-admin"
                onKeyDown={this.handleKeyDown}
              >
                <Modal.Header closeButton>
                  <Modal.Title id="example-custom-modal-styling-title">
                    {this.state.isCampUpdate
                      ? "Edit Campaign"
                      : "Create Campaign"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-0">
                  {!this.state.isCampUpdate ? (
                    <Row>
                      <Col
                        xs={12}
                        className="text-center"
                        style={{
                          backgroundColor: "rgba(214, 245, 255, 0.5)",
                          padding: "15px 0px",
                          borderBottom: "1px solid #c1dce6",
                        }}
                      >
                        <div>
                          <div className="custom-control custom-radio custom-radio-sm custom-control-inline">
                            <input
                              name="communicationType"
                              type="radio"
                              className="custom-control-input"
                              id="checkTemplate"
                              value={0}
                              onChange={(e) => this.selectCampaignCreate(e)}
                            />
                            <label
                              className="custom-control-label font-14 color-grey-1 font-500"
                              htmlFor="checkTemplate"
                            >
                              Clone Existing Template
                            </label>
                          </div>
                          <div className="custom-control custom-radio custom-radio-sm custom-control-inline">
                            <input
                              name="communicationType"
                              type="radio"
                              className="custom-control-input"
                              id="checkTemplate1"
                              value={1}
                              onChange={(e) => this.selectCampaignCreate(e)}
                            />
                            <label
                              className="custom-control-label font-14 color-grey-1 font-500"
                              htmlFor="checkTemplate1"
                            >
                              Create New Template
                            </label>
                          </div>
                        </div>
                      </Col>

                      {/* no template */}
                      {!this.state.isTemplateOptSelected ? (
                        <Col xs={12}>
                          <div className="text-center py-5">
                            <img
                              src={noTemplate}
                              alt="no template"
                              className="image-responsive"
                            />
                            <p
                              className="color-dark-blue mt-2"
                              style={{ fontSize: "19px" }}
                            >
                              Create new template or clone your existing
                              template
                            </p>
                          </div>
                        </Col>
                      ) : (
                        ""
                      )}
                    </Row>
                  ) : (
                    ""
                  )}

                  {this.state.isTemplateOptSelected ? (
                    <div>
                      <Row>
                        {this.state.isCampFromClone ? (
                          <Col xs={12}>
                            <div className="form-group mt-3">
                              <label className="form-label" htmlFor="email">
                                Select Existing Campaign
                                <span className="text-danger"> *</span>
                              </label>
                              <div className="c-select">
                                <select
                                  name="selectedCampaign"
                                  id=""
                                  className={
                                    "form-control font-14" +
                                    (errors.selectedCampaign &&
                                    touched.selectedCampaign
                                      ? " is-invalid"
                                      : "")
                                  }
                                  defaultValue={values.selectedCampaign}
                                  value={values.selectedCampaign}
                                  autoFocus={true}
                                  onBlur={(e) => {
                                    setFieldTouched(
                                      "selectedCampaign",
                                      true,
                                      true
                                    );
                                    setFieldValue(
                                      "selectedCampaign",
                                      e.target.value
                                    );
                                  }}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "selectedCampaign",
                                      e.target.value
                                    );

                                    setFieldValue(
                                      "contingencies",
                                      this.getContingenciesByCampIdForClone(
                                        e.target.value
                                      )
                                    );
                                  }}
                                >
                                  <option value="">Select</option>
                                  {this.existingCampaignList()}
                                </select>
                              </div>
                              <ErrorMessage
                                name="selectedCampaign"
                                component="div"
                                className="invalid-feedback"
                                style={{ display: "block" }}
                              />
                            </div>
                          </Col>
                        ) : (
                          ""
                        )}
                        <Col xs={9}>
                          <div className="form-group mt-3">
                            <label className="form-label" htmlFor="email">
                              Campaign Name
                              <span className="text-danger"> *</span>
                            </label>
                            <Field
                              name="campainName"
                              type="text"
                              value={values.campainName}
                              className={
                                "form-control form-control-sm field_ucfirst" +
                                (errors.campainName && touched.campainName
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="campainName"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                        <Col xs={3}>
                          <div className="form-group mt-3">
                            <label className="form-label" htmlFor="email">
                              Days<span className="text-danger"> *</span>
                            </label>
                            <Field
                              name="campaignDays"
                              type="number"
                              value={values.campaignDays}
                              className={
                                "form-control form-control-sm" +
                                (errors.campaignDays && touched.campaignDays
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="campaignDays"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={12} sm={3}>
                          <div className="form-group d-block">
                            <Field
                              type="checkbox"
                              name="default"
                              checked={values.default}
                              onChange={(e) => {
                                setFieldValue("default", e.target.checked);
                              }}
                              className="d-inline"
                            />
                            <label className="form-check-label d-inline ml-2">
                              Default
                            </label>
                          </div>
                        </Col>
                      </Row>

                      <hr className="sep-line mt-0 mb-1" />

                      <Row>
                        <Col xs="12">
                          <Contingencies
                            isMasterTemplate={true}
                            contingencies={values.contingencies}
                            setFieldValue={setFieldValue}
                          />
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}
                </Modal.Body>
                {this.state.isTemplateOptSelected ? (
                  <Modal.Footer>
                    <Button
                      type="submit"
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                    >
                      {this.state.isCampUpdate ? "Update" : "Create"}
                    </Button>
                  </Modal.Footer>
                ) : (
                  ""
                )}
              </Form>
            )}
          </Formik>
        </Modal>

        {/* Dependency Modal */}
        <Modal
          show={this.state.DependencyModal}
          onHide={() => this.DependencyModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med1 dependency-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Set Dependency
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <SetDependency
              options={this.state.dependencyTasks}
              actiontaken={this.state.actiontaken}
              predecessors={this.state.initialValueAddTask.predecessorData}
              dependencies={(e) => {
                this.closeModal(e);
              }}
              eventId={this.state.initialValueAddTask.eventtemplateId}
            />
          </Modal.Body>
        </Modal>

        {/* Delete Modal */}
        <Modal
          show={this.state.moveConfirmationModal}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400 modal-delete"
          centered
          backdrop={false}
        >
          <Modal.Body className="pb-0">
            <p className="text-center font-20 color-dark-blue">
              Are you sure you move this task?
            </p>
            <div className="px-1">
              <p className="mb-0 font-500 font-14">
                Here is the list of task that will be affected
              </p>
              <ul className="dependency-modal-task-list font-12">
                {this.state.affectedTasks.map((e, i) => {
                  if (e) {
                    return (
                      <li key={e.title}>
                        {" "}
                        Day - {e.day} {e.title}
                      </li>
                    );
                  }
                })}
              </ul>
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-center pt-2">
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => {
                this.changeCampaign(this.state.currentCampian._id);
                this.setState({ moveConfirmationModal: false });
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.confirmMove();
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Error Modal */}
        <Modal
          show={this.state.moveErrorModal}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400 modal-delete"
          centered
          backdrop={false}
        >
          <Modal.Body className="pb-0 text-center">
            {this.state.moveErrorMessage}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.closeErrorModal();
              }}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>

        <DeletePrompt
          deletePrompt={this.state.deletePrompt}
          itemId={this.state.userId}
          cancel={() => {
            this.setState({ deletePrompt: false });
          }}
          deleteConfirm={() => {
            this.deleteCampaignListById();
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminMasterTemplates: state.reducer.adminMasterTemplates,
    totalAdminTemplates: state.reducer.totalAdminTemplates,
    isEventCommCreated: state.reducer.isEventCommCreated,
    addedEventComm: state.reducer.addedEventComm,
    isMasterTemplateUpdated: state.reducer.isMasterTemplateUpdated,
    updatedEventData: state.reducer.updatedEventData,
    variablesRefs: state.reducer.variablesRefs,
    isMasterTemplateTaskDeleted: state.reducer.isMasterTemplateTaskDeleted,
    campDataById: state.reducer.campDataById,
    isCampaignCreated: state.reducer.isCampaignCreated,
    addedCampaign: state.reducer.addedCampaign,
    contingencies: state.reducer.allContingencies,
    dependencyTasks: state.reducer.dependencyTasks,
    specialTask: state.reducer.specialTask,
  };
};

export default connect(mapStateToProps, {
  adminGetMaterTemplateAction,
  adminUpdateMaterTemplateAction,
  adminCreatEventCommMaterTemplateAction,
  adminDelEventCommunicationAction,
  adminGetVarriableRefAction,
  adminGetCampDataByIdAction,
  adminCreatCampaignMaterTemplateAction,
  getAllContigencyAction,
  adminCopyCampaignMaterTemplateAction,
  GetDependencytasksAction,
  adminUpdateDependentTasksAction,
  getSpecialTaskAction,
  adminGetVariableRefAction,
  deleteSystemCampaignListAction,
})(MasterTemplate);
